import { useState, useEffect } from 'react';
import useDataBean from '../../../../core/services/dataBean/useDataBean';
import { _BudgetResource } from '../../../../core/services/dataBean/EntityCatalog';
import { _BudgetSource } from '../../../../core/services/dataBean/EntityCatalogVdos';

interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
    isDisabled?: boolean;
}

export const SelectBudgetSource = ({ idSelector, onChange, label, isDisabled }: Props) => {

    const { instance, lista, setLista } = useDataBean(_BudgetSource);
    const [id, setID] = useState(idSelector ?? null);

    useEffect(() => {
        if (idSelector) {
            setID(idSelector)
        }
    }, [idSelector])

    useEffect(() => {
        getLista();
    }, [])

    const setValue = (e: any) => {
        setID(parseInt(e));
        onChange(parseInt(e));
    }


    const getLista = () => {
        instance.getBudgetSourceCatalog(null).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                }
            }
        )

    }

    return (
        <>
            <label>{label ?? "Funte de Financiamiento"}</label>
            <select disabled={isDisabled} className="form-select" value={id} onChange={(e) => { setValue(e.target.value) }}>
                <option value="">...</option>
                {lista &&
                    lista.map((item: any, index: number) => {
                        return (
                            <option key={index} value={item.DataBeanProperties.IDBudgetSource} >{`${item.DataBeanProperties.IDBudgetSource ?? ""} - ${item.DataBeanProperties.Name ?? ""}`}</option>
                        )
                    })
                }
            </select>
        </>
    )
}